/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      route — gift voucher purchase page
 *   extends:   Route
 *   template:  none
 *   model:     none (uses the inherited default model hook)
 *   key:       setupController
 *   uses:      controllerFor('application') — collapses showCart/showMenu
 *              chrome
 *   siblings:  controllers/gift.js
 *   tests:     tests/unit/routes/simple-routes-test.js,
 *              tests/acceptance/gift-cart-test.js
 *   gotchas:   setupController explicitly clears giftSelected/gift_message/
 *              gift_style/paymentAPI on entry so a repeat gift purchase does
 *              not inherit the prior selection (maint 5.6 leak fix).
 *
 * Gift-voucher purchase route for the e-commerce storefront.
 */
import Route from '@ember/routing/route';

import { set } from '@ember/object';

export default class GiftRoute extends Route {
  setupController(controller, model) {
    super.setupController(controller, model);
    var application = this.controllerFor('application');
    set(application, 'showCart', null);
    set(application, 'showMenu', null);

    controller.set('paymentAPI', null);
    // Clear the previously-chosen gift product so a repeat gift purchase does not
    // inherit the prior selection (maint 5.6 leak fix).
    controller.set('giftSelected', null);
    controller.set('gift_message', null);
    controller.set('gift_style', null);
  }
}
